module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('h2', [_vm._v(_vm._s(_vm.$t('title.' + _vm.action + '.location')))]), _vm._v(" "), _c('el-row', {
    attrs: {
      "gutter": 40
    }
  }, [_c('el-col', {
    attrs: {
      "md": 12
    }
  }, [_c('data-form', {
    attrs: {
      "model": "locations",
      "entity": _vm.location,
      "fields": _vm.fields,
      "before-submit": _vm.beforeSubmit,
      "after-submit": _vm.afterSubmit
    }
  })], 1), _vm._v(" "), _c('el-col', {
    attrs: {
      "md": 12
    }
  }, [_c('h4', [_vm._v(_vm._s(_vm.$t('related-servers')))]), _vm._v(" "), _c('data-table', {
    attrs: {
      "model": "servers",
      "columns": ['fqdn'],
      "isSelected": _vm.isServerSelected
    },
    on: {
      "selection-change": _vm.serverSelectChanged
    }
  })], 1)], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-b8510840!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/location/LocationDetails.vue
// module id = 1184
// module chunks = 2